import Axios from 'axios'

export const searchMixin = {
    methods: {
        search: function (replaceSearchResults) {
            var vm = this
            vm.loading = true

            if (replaceSearchResults) {
                vm.$store.dispatch('resetSearchResults')
                vm.$store.dispatch('updateSearchFilter', { key: 'page', value: 1 })
                vm.$store.dispatch('updateSearchPageCount', 0)
                vm.$store.dispatch('updateSearchResultCount', 0)
                vm.$store.dispatch('updateSearchResultsLoaded', 0)
            }

            const getSearchResults = function () {
                return Axios.get(
                    vm.searchApiUrl + '?' + vm.$store.getters.searchFiltersQuerystring())
            }

            Axios.all([getSearchResults()])
                .then(Axios.spread(function (searchResults) {

                    if (searchResults && searchResults.data && searchResults.data.SearchResults) {

                        if (replaceSearchResults) {
                            vm.$store.dispatch('resetSearchResults')
                        }

                        vm.$store.dispatch('updateSearchPageCount', searchResults.data.PageCount)
                        vm.$store.dispatch('updateSearchResultCount', searchResults.data.ResultCount)
                        vm.$store.dispatch('updateSearchResults', searchResults.data.SearchResults)
                        vm.$store.dispatch('updateSearchResultsLoaded', vm.$store.state.search.resultsLoaded + searchResults.data.SearchResults.length)


                        // as we don't have a traditional form element, this allows us to capture form submissions in places that require that event e.g. Google Tag Manager
                        window.dataLayer = window.dataLayer || []

                        window.dataLayer.push({
                            event: 'formSubmissionSuccess',
                            formId: 'search'
                        })
                    } else {

                        vm.$store.dispatch('resetSearch')
                    }

                    vm.loading = false
                }))
                .catch(() => {
                    vm.loading = false
                })
        }
    }
}